// @ts-strict-ignore
import { PropsWithChildren, useEffect, useReducer } from 'react';
import { createCtx } from '@shared/util/context';
import { WorkflowTemplateFormData } from '../hooks';
import { WorkflowTemplateActions, WorkflowTemplateState, reducer } from './reducer';

type Dispatch = (action: WorkflowTemplateActions) => void;

export const [useWorkflowTemplateState, WorkflowTemplateStateProvider] =
  createCtx<WorkflowTemplateState>();
export const [useWorkflowDispatch, WorkflowTemplateDispatchProvider] = createCtx<Dispatch>();

type Props<T extends WorkflowTemplateFormData> = {
  initialWorkflowTemplate?: T;
  onUpdate?: (workflowTemplate: T) => void;
};

export function WorkflowTemplateProvider<T extends WorkflowTemplateFormData>({
  initialWorkflowTemplate,
  onUpdate,
  children,
}: PropsWithChildren<Props<T>>) {
  const [state, dispatch] = useReducer(reducer, { workflowTemplate: initialWorkflowTemplate });

  useEffect(() => {
    onUpdate(state?.workflowTemplate as unknown as T);
  }, [onUpdate, state]);

  return (
    <WorkflowTemplateStateProvider value={state}>
      <WorkflowTemplateDispatchProvider value={dispatch}>
        {children}
      </WorkflowTemplateDispatchProvider>
    </WorkflowTemplateStateProvider>
  );
}
